import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/database';
import 'firebase/compat/storage';
import 'firebase/compat/auth';
import 'firebase/compat/app-check';
import 'firebase/compat/functions';

const prodConfig = {
  apiKey: "AIzaSyDsAXJOwdFMP0sOa2mZ4jdzfSFKFDtsZm4",
  authDomain: "www.yourdocket.com",
  databaseURL: "https://docket-3257f.firebaseio.com",
  projectId: "docket-3257f",
  storageBucket: "docket-3257f.appspot.com",
  messagingSenderId: "446074423165",
  timestampsInSnapshots: true
};

const devConfig = {
  apiKey: "AIzaSyDSc11PWwNee7Ss-sb9VKmS13dUO8x8xbg",
  authDomain: "docket-dev-237ce.firebaseapp.com",
  databaseURL: "https://docket-dev-237ce.firebaseio.com",
  projectId: "docket-dev-237ce",
  storageBucket: "docket-dev-237ce.appspot.com",
  messagingSenderId: "803844309135",
  timestampsInSnapshots: true

};

const config = window.location.hostname === 'forms.yourdocket.com'
  ? prodConfig
  : devConfig;

// Initialize Firebase
const app = firebase.initializeApp(config);
window.docketConfig = config.authDomain === prodConfig.authDomain ? "prod" : "dev";
console.log('USING EMULATED FIREBASE:', process.env.REACT_APP_WITH_EMULATED_FIREBASE);
if (process.env.REACT_APP_WITH_EMULATED_FIREBASE && process.env.REACT_APP_WITH_EMULATED_FIREBASE.toLowerCase() === 'true') {
  app.auth().useEmulator(`http://localhost:${process.env.REACT_APP_DOCKET_EMULATED_AUTH_PORT}`, { disableWarnings: true });
  app.database().useEmulator('localhost', process.env.REACT_APP_DOCKET_EMULATED_DATABASE_PORT);
  app.firestore().useEmulator(
    'localhost',
    process.env.REACT_APP_DOCKET_EMULATED_FIRESTORE_PORT,
    {
      mockUserToken: {
        sub: '1',
        super: true,
      },
    }
  );
  app.functions().useEmulator('localhost', process.env.REACT_APP_DOCKET_EMULATED_FUNCTIONS_PORT);
  app.storage().useEmulator('localhost', process.env.REACT_APP_DOCKET_EMULATED_STORAGE_PORT);
}

// Initialize services
const db = firebase.database();
const storage = firebase.storage();
const firestore = firebase.firestore();
const auth = firebase.auth();

// Export services
export {
  db,
  storage,
  firestore,
  auth,
  app
};
